import { getAllowedActionsByGroup } from "features/cdm/utils/allowedActions";

const PROGRAMME_LABELS = {
  OCF: "Opportunistic Case Finding",
  PP: "Prevention Programme",
  CDM: "Chronic Disease Management",
};

// Maps the BE allowedActions into the "Start review" programme dropdown options,
// keeping only programmes that currently have at least one allowed action.
export const getCdmProgrammeOptions = (allowedActions) => {
  const groups = getAllowedActionsByGroup(allowedActions);

  return ["OCF", "PP", "CDM"]
    .filter((programme) => groups[programme].length > 0)
    .map((programme) => ({
      label: PROGRAMME_LABELS[programme],
      value: programme,
    }));
};
